import { Component } from '@angular/core';

@Component({
  selector: 'qmu-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'qmutator';
}
